import { StakingType, useIntl, useSettings } from '@capsicum/common';
import { env } from '@capsicum/common-web';
import { type NCWalletTokenCardsBalanceEntry } from '@capsicum/features/nc-wallet/shared';
import { useFanTokenStakingConfig } from '@capsicum/socios-core';
import { useFanTokenStakingNavigationOnDemand } from '@capsicum/socios-core-web';

import { useNCWPartnerRouting } from '../../hooks/useNCWPartnerRouting';
import { NCWalletTokenListCard } from '../nc-wallet-token-list-card/NCWalletTokenListCard';

import type { NCWalletTokenListCardProps } from '../nc-wallet-token-list-card/NCWalletTokenListCard';

type NCWalletTokenListCardWithStakingProps = NCWalletTokenListCardProps & {
	entry: NCWalletTokenCardsBalanceEntry;
};

export const NCWalletTokenListCardWithStaking = ({ entry, ...props }: NCWalletTokenListCardWithStakingProps) => {
	const { $t } = useIntl();
	const {
		settings: { isWalletConnectEnabled }
	} = useSettings();
	const { isAllowed: isStakeAllowed } = useFanTokenStakingConfig(StakingType.STAKE);
	const { routeToPepperStaking } = useNCWPartnerRouting();

	const { isLoading: isStakeLoading, navToFanTokenStake } = useFanTokenStakingNavigationOnDemand();

	const getStakingProps = () => {
		if (!isStakeAllowed || !entry.currencyId || entry.tokenType !== 'partner') return {};

		const { currencyId, partnerID, stakeOperationId } = entry;

		if (currencyId === env.NEXT_PUBLIC_PEPPER_CURRENCY_ID && isWalletConnectEnabled) {
			return {
				currencyId,
				onPrimaryButtonClick: () => routeToPepperStaking(),
				partnerId: partnerID,
				primaryButtonLabel: $t('staking.fanTokenStaking.pepperStakeButtonLabel')
			};
		}

		if (stakeOperationId) {
			return {
				currencyId,
				isPrimaryButtonLoading: isStakeLoading,
				onPrimaryButtonClick: () => navToFanTokenStake(currencyId),
				partnerId: partnerID,
				primaryButtonLabel: $t('staking.fanTokenStaking.stakeButtonLabel')
			};
		}

		return {};
	};

	return <NCWalletTokenListCard {...props} {...getStakingProps()} />;
};
